/* Coco y Luna – Producto que vuela al carrito */
(function () {
  if (window.__cylFlyToCart) return;
  window.__cylFlyToCart = true;

  var BUTTONS = '[data-add-to-cart], [data-quick-add], [data-card-size-add], .sticky-atc button[type="submit"]';
  var CART = '.header__icon[data-drawer-open="CartDrawer"]';
  var DURATION = 820;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function visible(el) {
    var r = el.getBoundingClientRect();
    return r.width > 0 && r.height > 0;
  }
  function inViewport(r) {
    return r.bottom > 0 && r.right > 0 && r.top < innerHeight && r.left < innerWidth;
  }
  function firstVisibleImg(root) {
    if (!root) return null;
    var imgs = root.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      if (visible(imgs[i]) && inViewport(imgs[i].getBoundingClientRect())) return imgs[i];
    }
    for (var j = 0; j < imgs.length; j++) if (visible(imgs[j])) return imgs[j];
    return null;
  }
  function findCart() {
    var all = document.querySelectorAll(CART);
    for (var i = 0; i < all.length; i++) if (visible(all[i])) return all[i];
    return null;
  }
  function findImage(btn) {
    var card = btn.closest('.card');
    if (card) return firstVisibleImg(card.querySelector('.card__media') || card);
    var form = document.querySelector('form[data-product-form]');
    var section = form && form.closest('.shopify-section');
    return firstVisibleImg(section) || firstVisibleImg(document.getElementById('MainContent'));
  }
  function bump(cart) {
    if (!cart.animate) return;
    cart.animate(
      [
        { transform: 'scale(1)' },
        { transform: 'scale(1.3) rotate(-8deg)' },
        { transform: 'scale(.94) rotate(4deg)' },
        { transform: 'scale(1)' }
      ],
      { duration: 460, easing: 'ease-out' }
    );
  }

  function fly(btn) {
    var cart = findCart();
    if (!cart) return;
    if (reduce) { bump(cart); return; }

    var img = findImage(btn);
    if (!img) { bump(cart); return; }

    var from = img.getBoundingClientRect();
    // Si la foto no está a la vista (p. ej. barra fija), sale desde el botón
    if (!inViewport(from)) {
      var b = btn.getBoundingClientRect();
      var size = 80;
      from = { left: b.left + b.width / 2 - size / 2, top: b.top - size / 2, width: size, height: size };
    }
    var to = cart.getBoundingClientRect();

    var clone = img.cloneNode(true);
    clone.removeAttribute('id');
    clone.removeAttribute('loading');
    clone.removeAttribute('class');
    clone.setAttribute('aria-hidden', 'true');
    clone.style.cssText =
      'position:fixed;margin:0;z-index:2147483000;pointer-events:none;object-fit:cover;' +
      'transform-origin:center center;will-change:transform,opacity;' +
      'box-shadow:0 14px 34px rgba(0,0,0,.25);border-radius:4px;' +
      'left:' + from.left + 'px;top:' + from.top + 'px;width:' + from.width + 'px;height:' + from.height + 'px;';
    document.body.appendChild(clone);

    var dx = to.left + to.width / 2 - (from.left + from.width / 2);
    var dy = to.top + to.height / 2 - (from.top + from.height / 2);
    var endScale = Math.min(1, 26 / Math.max(from.width, from.height));
    var arc = Math.min(180, Math.max(60, Math.abs(dx) * 0.25));
    var start = performance.now();

    function frame(now) {
      var t = Math.min((now - start) / DURATION, 1);
      var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      var x = dx * e;
      var y = dy * e - arc * 4 * e * (1 - e);
      var s = 1 + (endScale - 1) * e;
      clone.style.transform = 'translate(' + x + 'px,' + y + 'px) scale(' + s + ')';
      clone.style.borderRadius = (4 + 46 * e) + '%';
      clone.style.opacity = String(1 - 0.45 * e);
      if (t < 1) requestAnimationFrame(frame);
      else { clone.remove(); bump(cart); }
    }
    requestAnimationFrame(frame);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(BUTTONS);
    if (!btn || btn.disabled || btn.hasAttribute('data-buy-now')) return;
    if (btn.hasAttribute('data-card-size-add') && !btn.dataset.quickAdd) return;
    fly(btn);
  }, true);

  window.flyToCart = fly;
})();
